import client from './client.js';

// posOnly: true → el backend solo devuelve organizaciones con POS activo,
// así el cajero no ve tenants donde no puede operar caja.
export const lookupTenants = (email) =>
  client.post('/auth/lookup-tenants', { email, posOnly: true }).then((r) => r.data);

export const login = (email, password, tenantId) =>
  client.post('/auth/login', { email, password, tenantId }).then((r) => r.data);
